let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k5lf7")).then(() => parcelRequire('lq5RB'));